import { IOption } from 'src/components/ui-kit/ReactSelect';
import { IPageData, IReqPage } from './pageTypes';
import { CertPdfChkDetail } from './patentRightsApiTypes';
import { PersonComplete, Transfer } from './personTypes';
import { IOrder, ISearchCondition } from './searchConditionType';

/** 商標查詢參數 */
export interface IReqTmarkRights {
  /** 權利是否存續。 */
  isEffective?: string;

  /** 搜尋號相關項目及值 */
  searchNo?: ISearchCondition;

  /** 註冊公告日期起。 */
  regNoticeBDate?: string;

  /** 註冊公告日期迄。 */
  regNoticeEDate?: string;

  /** 商標名稱。 */
  tmarkName?: string;

  /** 搜尋人員名稱相關項目及值 */
  searchName?: ISearchCondition;

  /** 專用期限起。 */
  deadlineBDate?: string;

  /** 專用期限迄。*/
  deadlineEDate?: string;

  /** 商標樣態代碼。*/
  tmarkType?: string;
}

export interface IReqTmarkRightsPage extends IReqTmarkRights, IReqPage, IOrder {}

/** 商標回傳結果 */
export interface IResTmarkRights {
  /** 商標種類。 */
  tmarkClass: string;

  /** 註冊號。 */
  examNo: string;

  /** 商標圖樣路徑。 */
  tmarkImageUrl: string;

  /** 商標名稱。 */
  tmarkName: string;

  /** 商標權人中文名稱。 */
  holdersNameC: string[];

  /** 註冊日期。*/
  regDate: string;

  /** 專用期限。*/
  deadlineDate: string;
}

export type IResTmarkRightsPage = IPageData<IResTmarkRights>;

/** 商標案件明細回傳結果 */
export interface IResTmarkRightsDetail {
  /** 商標權狀態異動資料。 */
  tmarkRight: TmarkRightsDetail;
  /** 商標權狀態異動資料。 */
  tmarkChange: TmarkChange;
  /** 商標權狀態異動資料。 */
  tmarkDivide: TmarkDivide;
  /** 商標權狀態異動資料。 */
  tmarkPriorityContent: TmarkPriorityContent;
  /** 專利案件讓與紀錄。 */
  certPdfChkDetail: CertPdfChkDetail;
  /** QR code 圖片(base64編碼)。 */
  qrCodeImage: string;
  /** QR code uuid check api result code。 */
  qrCodeApiResultCode: string;
}

/**
 * 權利是否存續。
 */
export enum ApplNow {
  All = '全部',
  Y = '是',
  N = '否',
}

/**
 * 商標搜尋項目(商標號)。
 */
export const TrademarkSearchNoOptions: IOption[] = [
  { value: 'examno', label: '商標註冊號數' },
  { value: 'applno', label: '申請案號' },
];

/**
 * 商標搜尋項目(商標權人)。
 */
export const TrademarkSearchNameOptions: IOption[] = [
  { value: 'applnamec', label: '商標權人中文名稱' },
  { value: 'applnamee', label: '商標權人英文名稱' },
  { value: 'agentname', label: '代理人名稱' },
];

/**
 * 商標樣態。
 */
export const TmarktypeOptions: IOption[] = [
  { value: '0', label: '全部' },
  { value: '1', label: '聲音' },
  { value: '2', label: '立體' },
  { value: '3', label: '平面' },
  { value: '4', label: '顏色' },
  { value: '5', label: '全像圖' },
  { value: '6', label: '動態' },
  { value: '9', label: '其他' },
];

/**
 * 商標搜尋結果排序選項。
 */
export const TmarkOrderOptions: IOption[] = [
  { value: 'exam-no', label: '註冊號' },
  { value: 'appl-no', label: '申請案號' },
  { value: 'appl-date', label: '申請日期' },
  { value: 'receive-date', label: '首次收文日' },
  { value: 'reg-date', label: '註冊日期' },
  { value: 'reg-notice-date', label: '註冊公告日期' },
  { value: 'exam-notice-date', label: '審定公告日期' },
  { value: 'del-reason', label: '撤銷原因' },
  { value: 'deadline', label: '專用期限' },
];

/** 商標權狀態異動資料。 */
export interface TmarkRightsDetail {
  /** 註冊號。 */
  examNo: string;

  /** 申請號。 */
  applNo: string;

  /** 商標名稱。 */
  tmarkName: string;

  /** 商標種類。 */
  tmarkClass: string;

  /** 商標種類描述。 */
  tmarkClassDesc: string;

  /** 商標圖樣路徑。 */
  tmarkImageUrls: TmarkImageUrls[];

  /** 商標樣態。*/
  tmarkType: string;

  /** 商標樣態描述。*/
  tmarkTypeDesc: string;

  /** 圖樣顏色。*/
  tmarkColor: string;

  /** 圖樣顏色描述。*/
  tmarkColorDesc: string;

  /** 圖樣中文。*/
  tmarkDraftC: string;

  /** 圖樣英文。*/
  tmarkDraftE: string;

  /** 圖樣日文。*/
  tmarkDraftJ: string;

  /** 圖樣記號。*/
  tmarkSign: string;

  /** 說明文字內容。*/
  wordDescription: string;

  /** 商品或服務類別資訊。 */
  goodsClasses: GoodsClass[];

  /** 專用期限。*/
  deadline: string;

  /** 首次收文日。*/
  receiveDate: string;

  /** 申請日期。*/
  applDate: string;

  /** 註冊日期。*/
  regDate: string;

  /** 註冊公告日期。*/
  regNoticeDate: string;

  /** 審定公告日期。*/
  examNoticeDate: string;

  /** 撤銷原因。*/
  delReason: string;

  /** 公告卷數。*/
  volNo1: string;

  /** 公告期數。*/
  volNo2: string;

  /** 實體審承辦人姓名。 */
  processorName: string;

  /** 異議狀況。*/
  oppositionStatus: number;

  /** 評定狀況。 */
  examStatus: number;

  /** 舉發狀況。 */
  nullityActStatus: number;

  /** 撤銷廢止狀況。 */
  applDelStatus: number;

  /** 授權狀況。 */
  autStatus: number;

  /** 再授權狀況。 */
  agaAutStatus: number;

  /** 展延狀況。 */
  extendedStatus: number;

  /** 變更狀況。 */
  amedmentStatus: number;

  /** 移轉狀況。 */
  transferStatus: number;

  /** 提評狀況。 */
  issueOppStatus: number;

  /** 報撤狀況。 */
  issueDelStatus: number;

  /** 設定質權狀況。 */
  quotaStatus: number;

  /** 禁止處分狀況。 */
  unableUseStatus: number;

  /** 擁有者資訊。 */
  holders: PersonComplete[];

  /** 代理人資訊。 */
  agents: PersonComplete[];
}

/** 商標圖樣路徑。 */
interface TmarkImageUrls {
  imageData1: string;

  imageData2: string;

  imageData3: string;

  imageData4: string;

  imageData5: string;

  imageData6: string;

  audioFilename: string;
}

/** 商品或服務類別資訊。 */
export interface GoodsClass {
  /** 商品或服務類別代碼。 */
  goodsClassCode: string;

  /** 商品名稱。 */
  goodsName: string;

  /** 類似組群。 */
  goodsGroup: string;
}

/** 商標權狀態異動資料。 */
export interface TmarkChange {
  /** 移轉序資訊。 */
  alterations: TmarkChangeAlteration[];
}

/** 移轉序資訊。 */
export interface TmarkChangeAlteration {
  /** 序號。 */
  sequence: number;

  /** 移轉公告日期。 */
  noticeDate: string;

  /** 移轉公告卷數。 */
  volumnNo: string;

  /** 移轉公告期數。 */
  issueNo: string;

  /** 商標註冊案受讓人資訊。 */
  parties: Transfer[];
}

/** 商標權狀態異動資料。 */
export interface TmarkDivide {
  /** 分割日期。 */
  divideDate: string;

  /** 原註冊號。 */
  tmarkDivideOrigin: TmarkDivideOrigin;

  /** 原註冊號商標種類代碼。 */
  origintmarkClass: string;
}

interface TmarkDivideOrigin {
  /** 原註冊號。 */
  originExamNo: string;
}

/** 商標權狀態異動資料。 */
export interface TmarkPriorityContent {
  /** 序號。 */
  sequence: number;

  /** 優先權資訊。 */
  priority: TmarkPriority;
}

/** 優先權資訊。 */
interface TmarkPriority {
  /** 優先權日期。 */
  date: string;

  /** 優先權類別。 */
  type: string;

  /** 首次申請國家。 */
  country: string;

  /** 展覽會名稱。 */
  remark: string;
}
